import useTranslations from '@/i18n/useTranslations';
import { FormDropdown } from '@/shared-components/dropdown';
import FormError from '@/shared-components/error/components/FormError';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';

import './styles/PersonalizedTime.css';

export default function PersonalizedTime({ formState, setFormState, error }) {
  const t = useTranslations('common.profile.pages.artlist');
  const timeUnits = [
    { label: t('time_selector.units.seconds'), value: 'seconds' },
    { label: t('time_selector.units.minutes'), value: 'minutes' },
    { label: t('time_selector.units.hours'), value: 'hours' },
  ];

  function updateFormState(key, value) {
    setFormState({
      ...formState,
      [key]: value
    });
  }

  return (
    <>
      <div className={`personalized-time__container ${formState.time_selected === "personalized" ? "expanded" : ""}`}>
        <PublicFormInput 
          placeholder={t('time_selector.fields.personalized_quantity')} 
          element="time_quantity" 
          type="number"
          value={formState.time_selected === "personalized" ? formState.time_quantity : ""}
          onChange={(e) => updateFormState("time_quantity", e.target.value)}
        />
                
        <FormDropdown
          label={t('time_selector.fields.time_unit')}
          element="time_unit"
          options={timeUnits}
          value={formState.time_selected === "personalized" ? (formState.time_unit || "seconds") : ""}
          onChange={newValue => updateFormState("time_unit", newValue)}
          formatValue={selectedValue => timeUnits.find(({ value }) => value === selectedValue)?.label || ''}
        />

      </div>

      <FormError error={error} element="time_quantity"/>
    </>
  );
}
